import script from "./Divider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Divider.vue?vue&type=script&setup=true&lang=ts"

import "./Divider.vue?vue&type=style&index=0&id=6695399c&lang=scss"

const __exports__ = script;

export default __exports__